import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_CLIENTS',
    icon: 'UserIcon',
    action: constants.action.permissionClientView,
    resource: constants.resource.client,
    companyOnly: true,
    route: 'clients-list',
  },
]
